import React from 'react';
import { Modal, Button, Alert, Table } from 'react-bootstrap';
import { formatCurrency, formatDate } from '../../../../utils/formatters';
import { MAX_CARES_GRANTS, MAX_CARES_AMOUNT, BENEFIT_FUND_TYPES } from '../../../../constants/constants';
import { getFundTypeLabel } from '../../../../utils/fundTypeUtils';

const PledgeLimitReachedModal = ({ fundType, show, handleClose, pledgesApplied }) => {
  const FUND_TYPE_LABEL = getFundTypeLabel(fundType);

  return (
    <Modal show={show} onHide={handleClose} centered >
      <Modal.Header className="bg-warning-subtle">
        <Modal.Title>{FUND_TYPE_LABEL} Pledge Maximum Reached</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="mb-3">
          <strong>This customer has reached the {FUND_TYPE_LABEL} Pledge maximum for this program year.</strong>
        </Alert>

        <p>{FUND_TYPE_LABEL} pledges applied this year:</p>
        <Table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {pledgesApplied.map((pledge, index) => (
              <tr key={index}>
                <td>{formatDate(pledge?.appliedDate)}</td>
                <td>{formatCurrency(pledge?.pledgeAmount, '-')}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PledgeLimitReachedModal;